export default{

    SZABLONY_EBOK:[

        {
            value:"S1",
            label:"Bilet został anulowany",
            tresc:"Dzień dobry, \nBilet  został anulowany i płatność zwrócona. \nSerdecznie pozdrawiamy, zespół Marcel-Bus"
        },

        {
            value:"S2",
            label:"Bilet został anulowany, zwrócono płatnosć w wysokości...",
            tresc:"Dzień dobry, \nBilet  został anulowany i płatność zwrócona w wysokości _ zł. \nSerdecznie pozdrawiamy, zespół Marcel-Bus"
        },

        {
            value:"S3",
            label:"Bilet został anulowany, ale płatność nie została zwrócona - był poniżej 1,10zł",
            tresc:"Dzień dobry, \nBilet został anulowany lecz płatność nie została zwrócona \nOd zwracanych  Pasażerowi przez Przewoźnika należności, Przewoźnik potrąca 20% odstępnego. Minimalna opłata przy zwrocie wynosi 1,10 zł. Przy zwrocie za bilet na przykład po 1 zł zaistniałaby dopłata w wysokości 10gr. \nSerdecznie pozdrawiamy, zespół Marcel-Bus"
        },






    ],

    // zdefiniowane jest w templatkach
    RODO: "\n\nAdministratorem danych osobowych (ADO) przetwarzanych w ramach prowadzonej korespondencji jest MARCEL Sp. z o.o. Sp. K. z siedzibą w Rzeszowie przy ul. Architektów 1B; 35 – 105 Rzeszów. Z ADO można się kontaktować: listownie, na adres: ul. Architektów 1B; 35 – 105 Rzeszów lub za pośrednictwem poczty e – mail, na adres: ochrona_danych@marcel-bus.pl. Aby sprawdzić w jakim celu i na jakiej podstawie przetwarzamy dane osobowe proszę przejść na adres http://marcel-bus.pl/wp-content/uploads/polityka.pdf ."

}


// WEBPACK FOOTER //
// ./src/utilities/templates/EBOK_templates.js